import React from 'react';
import Layout from '../../components/Layout/Layout';
import './About.css';

const About = () => {
  return (
    <Layout>
      <main className="info-page">
        <section className="info-panel">
          <h1>About SNAGITCHEAP.COM</h1>
          <p>
            SNAGITCHEAP.COM helps shoppers find practical deals across tools, home goods, electronics,
            household essentials, and hard-to-find items.
          </p>
          <p>
            We focus on clear product details, straightforward pricing, and inventory that can move
            quickly, so every listing is built to make comparison and checkout easier.
          </p>
        </section>

        <section className="info-grid">
          <div className="info-card">
            <h2>What We Sell</h2>
            <p>Discounted products across everyday categories, including new, used, refurbished, and like-new items.</p>
          </div>
          <div className="info-card">
            <h2>How We Work</h2>
            <p>Each product page highlights condition, availability, shipping, delivery, warranty, and return details when offered.</p>
          </div>
          <div className="info-card">
            <h2>Need Help?</h2>
            <p>Reach out before ordering if you need clarification about a product, pickup, delivery, or policy details.</p>
          </div>
        </section>
      </main>
    </Layout>
  );
};

export default About;
